


const API_USER_RATING_REQUEST = 'API_USER_RATING_REQUEST';
const RESET_CODE_REQUEST = 'RESET_CODE_REQUEST';
const API_USER_RATING_SUCCESS = 'API_USER_RATING_SUCCESS';
const API_USER_RATING_FAILURE = 'API_USER_RATING_FAILURE';





export const userRatingsRequest = payload => ({
  type: API_USER_RATING_REQUEST,
  payload: payload
});

export const userRatingsSuccess = payload => ({
  type: API_USER_RATING_SUCCESS,
  payload,
});

export const userRatingsFailure = payload => ({
  type: API_USER_RATING_FAILURE,
  payload,
});

export const resetCodeRequest = payload => ({
  type: RESET_CODE_REQUEST,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  message:null
};

export function userRatingReducer(state = initialState, action) {
 
  switch (action.type) {
    case API_USER_RATING_REQUEST:
    
    return {
      ...state,
      fetching: true,
      isFetched: false
    };
    case RESET_CODE_REQUEST:
    
    return {
      ...state,
      codeMessage: null
    };
     
    case API_USER_RATING_SUCCESS:
    
      return {
        ...state,
        error: null,
        fetching: false,
        isFetched: true,
        message: action.payload
      };
    case API_USER_RATING_FAILURE:
    
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
